import { ReportUrl } from "@common";
import { HoverIcon, SvgBackground } from "@components";
import {
    CreativesOff,
    CreativesOn,
    GeographicIconOff,
    GeographicIconOn,
    InfoOff,
    InfoOn,
    AudiencesOff,
    AudiencesOn
} from "@icons";
import * as cn from "classnames";
import * as React from "react";
import { Link } from "react-router-dom";
import "./ReportNavigation.css";

interface ReportTabProps {
    title: string;
    icon: string;
    iconHover: string;

    url: string;
    isActive: boolean;

    badIcon?: boolean;
}

function ReportButton({ icon, iconHover, url, title, isActive }: ReportTabProps) {
    return (
        <HoverIcon className="report-nav-tab-wrapper" hoverBehavoir={isActive ? "hover" : "dynamic"}>
            {isHover => (
                <Link to={url} className={cn("report-navigation-tab", { active: isActive })}>
                    <span className="report-navigation-tab__title">{title}</span>
                    <SvgBackground className="reports-nav-icon" svg={isHover ? iconHover : icon} />
                </Link>
            )}
        </HoverIcon>
    );
}

export interface ReportNavigationProps {
    className?: string;
}
export function ReportNavigation(props: ReportNavigationProps) {
    const match = ReportUrl.match(window.location, true);

    return (
        <div className={cn("report-navigation", props.className)}>
            <ReportButton
                title="Performance"
                icon={InfoOff}
                iconHover={InfoOn}
                isActive={match.isMatched && match.params.tab === "dynamic"}
                url={ReportUrl.replace(window.location, { tab: "dynamic" })}
            />
            <ReportButton
                title="Audience"
                icon={AudiencesOff}
                iconHover={AudiencesOn}
                isActive={match.isMatched && match.params.tab === "audience"}
                url={ReportUrl.replace(window.location, { tab: "audience" })}
            />
            <ReportButton
                title="Geographic"
                icon={GeographicIconOff}
                iconHover={GeographicIconOn}
                isActive={match.isMatched && match.params.tab === "geographic"}
                url={ReportUrl.replace(window.location, { tab: "geographic" })}
            />
            <ReportButton
                title="Creative"
                icon={CreativesOff}
                iconHover={CreativesOn}
                isActive={match.isMatched && match.params.tab === "creative"}
                url={ReportUrl.replace(window.location, { tab: "creative" })}
            />
        </div>
    );
}
